<div class="beachy-app-dialog">
  @if (data.title) {
    <h4 mat-dialog-title
    [ngClass]="{ 
      'dialog__title--error' : hasError,
      'dialog__title--normal' : !hasError
    }"
      >
      {{data.title}}
    </h4>
  }
  <mat-dialog-content style="padding: 0;">
    @if (data.error) {
      <p class="dialog-text__error">{{ data.error.message || data.error }}</p>
    }
    @if (data.message) {
      <p class="dialog-text__message" >{{ data.message }}</p>
    }
    @if (!data.error && !data.message) {
      <p class="dialog-text__message" >Sorry, something went wrong.</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions style="padding: 20px 0 0;">
    <button class="dialog__button"
      [ngClass]="{
        'dialog__button--error' : hasError,
        'dialog__button--normal' : !hasError
      }"
      (click)="onNoClick()">
      OK
    </button>
  </mat-dialog-actions>
</div>
